import { useCallback, useEffect, useState } from 'react'
import { Wapprunner } from '../wapprunner'
import { addToWappPool } from '../../wapprunner-pool/wapprunnerPool.ops'
import { WappSessionCreator } from '../../common'
import { WappMode } from '@weblite-wapps/protocol'

export const WapprunnerCreate = ({
  wappSessionId: initialWappSessionId,
  wappId,
  wisId,
  mode,
  input,
  parentWapp,
}: WappSessionCreator) => {
  const [wappSessionId, setWappSessionId] = useState<string>(null)

  const logger = useCallback(
    (...args: any[]) => {
      if (mode === WappMode.INLINE) console.log(...args)
    },
    [mode],
  )

  useEffect(() => {
    const initiateWapp = async () => {
      const date = Date.now()
      logger('BEFORE_GET_SESSION_ID', date)
      const sessionId = await addToWappPool({
        wappSessionId: initialWappSessionId,
        wappId,
        wisId,
        input,
        mode,
        parentWapp,
      })

      logger('SET_SESSION_ID:', sessionId, date)
      setWappSessionId(sessionId)
      return sessionId
    }

    initiateWapp()
  }, [logger])

  logger({ wappSessionId })

  return wappSessionId ? (
    <Wapprunner key={wappSessionId} wappSessionId={wappSessionId} />
  ) : null
}

WapprunnerCreate.defaultProps = {
  wisId: undefined,
  input: null,
  parentWapp: null,
}
